import React, { createContext, useState } from "react";

interface Context {
  setPreviewPage: (pg: string) => void,
  originalPage: string
}

export const NotificationContext = createContext<Context>({
  setPreviewPage: () => { },
  originalPage: "home",
});

export const NotificationProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [originalPage, setPreviewPage] = useState<string>("home");

  const setPage = (pg: string): void => {
    setPreviewPage(pg);
  };
  return (
    <NotificationContext.Provider
      value={{
        setPreviewPage: setPage,
        originalPage,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
